import type { ReactNode } from 'react';
import { cx } from '../../lib/util/cx';

/**
 * Port of the DS `EmptyState`: short, blame-free, action-first, terminal
 * period — "No chefs match those filters." / "Nothing here yet."
 */
export function EmptyState({
  title = 'Nothing here yet.',
  body,
  action,
  illustration,
  compact = false,
}: {
  title?: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  illustration?: ReactNode;
  compact?: boolean;
}) {
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center gap-2.5 text-center font-body',
        compact ? 'px-5 py-7' : 'px-6 py-14',
      )}
    >
      {illustration && <div className="mb-1.5">{illustration}</div>}
      <div
        className={cx(
          'font-heading font-bold tracking-[-.01em] text-brown-deep',
          compact ? 'text-base' : 'text-[19px]',
        )}
      >
        {title}
      </div>
      {body && <p className="m-0 max-w-[44ch] text-sm leading-[1.55] text-muted">{body}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
